module.exports = __webpack_public_path__ + "static/media/blue.93efb26a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header/layers/blue.png
// module id = 276
// module chunks = 0